// extracted by mini-css-extract-plugin
module.exports = {"center":"login_center__ozBIZ","content":"login_content__MKSdE"};